import React, { createContext, useState } from "react";
import { Toast } from "../components/common/Toast";
import HomePageProductService from "../services/HomePageProductService";

export const HomePageProductContext = createContext("HomePageProductContext");

const HomePageProductContextProvider = ({ children }) => {
	const [homePageProductList, setHomePageProductList] = useState([]);
	const [loadingHomePageProductList, setLoadingHomePageProductList] =
		useState(false);
	const [homePageProductListErrorMsg, setHomePageProductListErrorMsg] =
		useState("");

	const getHomePageProductList = async (params) => {
		setLoadingHomePageProductList(true);
		try {
			setHomePageProductListErrorMsg("");
			const response =
				await HomePageProductService.getHomePageProductsList(params);
			setHomePageProductList(response.data.content);
		} catch (error) {
			const message = error.response
				? error.response.data.message
					? error.response.data.message
					: error.response.data
				: error.message;
			setHomePageProductListErrorMsg(message);
			Toast("error", "Error", message);
		} finally {
			setLoadingHomePageProductList(false);
		}
	};

	return (
		<HomePageProductContext.Provider
			value={{
				getHomePageProductList,
				homePageProductList,
				loadingHomePageProductList,
				homePageProductListErrorMsg,
			}}
		>
			{children}
		</HomePageProductContext.Provider>
	);
};

export default HomePageProductContextProvider;
